export default {
  sanitize: {
    type: 'object',
    properties: {}
  },
  validate: {
    insert: {
      type: 'object',
      properties: {}
    },
    update: {
      type: 'object',
      properties: {}
    },
    delete: {
      type: 'object',
      properties: {}
    }
  }
}
